import { styled } from '@mui/system'
import type { CSSProperties } from 'react'
import { Card } from '../../overview.styles'

export const Container = styled('div')`
    border-radius: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    
`

export const Header = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const ChartContainer = styled('div')`
    height: 300px;
    position: relative;
`

export const StyledCard = styled(Card)`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const fadeInCenterLabel = {
  '@keyframes fadeInCenterLabel': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}

export const CenterLabel = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{
  color?: CSSProperties['color']
}>(({ color, theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
  fontSize: 20,
  fontWeight: 600,
  color: color || theme?.palette?.text?.primary,
  opacity: 0,
  animation: 'fadeInCenterLabel 0.5s ease-in forwards',
  ...fadeInCenterLabel,
}))
